module.exports = __webpack_public_path__ + "static/media/-ve5.3c4ace9b.png";